module.exports = __webpack_public_path__ + "/build/web/images/testimonials-left-1-2@2x.4ae555d22f679e3c8d6584643e41c46c.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/testimonials-left-1-2@2x.jpg
// module id = 198
// module chunks = 13